/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 29.04.2016
 *
 */
'use strict';

import {
    AppContext,
    ConfirmFormContainer,
    ContextContainer,
    CustomModal,
    CustomModalBody,
    DataUtil,
    FormActions,
    wrapWithCommonFormContainer
} from 'plugin/liferay-widgets-react-web';

import React from 'external/react';
import { Button, ButtonToolbar } from 'external/react-bootstrap';

import MapConfigActions from '../actions/MapConfigActions';
import LogicalLayerActions from '../actions/LogicalLayerActions';

import MapConfigChooser from '../components/MapConfigChooser';
import MapConfigEditForm from '../components/MapConfigEditForm';
import DefaultMapConfigEditForm from '../components/DefaultMapConfigEditForm';
import MapConfigCopyForm from '../components/MapConfigCopyForm';

import { getLogicalLayerStore, getMapConfigStore } from '../stores/StoreFactory';

const MapConfigStore = getMapConfigStore(AppContext);
const LogicalLayerStore = getLogicalLayerStore(AppContext);

let MapConfigEditFormHoc = wrapWithCommonFormContainer(MapConfigEditForm);
let DefaultMapConfigEditFormHoc = wrapWithCommonFormContainer(DefaultMapConfigEditForm);

class MapConfigWidget extends React.Component {

    constructor(props) {
        super(props);

        this.DATA = {
            GROUP_MAP_CONFIGS: this.withCtx('_GroupMapConfigs'),
            MAP_CONFIGS: this.withCtx('_MapConfigs'),
            LOGIC_LAYERS: this.withCtx('_LogicLayers'),
            FORM_MAPCONFIGEDITFORM: this.withCtx('_MapConfigEditForm'),
            FORM_DEFAULTMAPCONFIGFORM: this.withCtx('_DefaultMapConfigForm'),
            FORM_RESETDEFAULTMAPCONFIGFORM: this.withCtx('_ResetDefaultMapConfigForm')
        };

        this.state = {
            showCopyModal: false
        };
    }

    componentDidMount() {
        MapConfigActions.allList(this.DATA.GROUP_MAP_CONFIGS);
        MapConfigActions.allGroupedList(this.DATA.MAP_CONFIGS);

        LogicalLayerActions.allViewableGroupedList(this.DATA.LOGIC_LAYERS);
    }

    static getStores() {
        return [
            MapConfigStore,
            LogicalLayerStore
        ];
    }

    static calculateState(prevState, prevProps, DATA) {
        return {
            ...prevState,

            groupMapConfigs: MapConfigStore.getRemoteData(DATA.GROUP_MAP_CONFIGS),
            mapConfigs: MapConfigStore.getRemoteData(DATA.MAP_CONFIGS),
            logicalLayers: LogicalLayerStore.getRemoteData(DATA.LOGIC_LAYERS)
        };
    }

    withCtx(s) {
        return this.portletId + '.' + s;
    }

    onNewMapConfig() {
        FormActions.startEditFormItem(this.DATA.FORM_MAPCONFIGEDITFORM, {});
    }

    openDefaultMapConfigForm() {
        const mapConfig = MapConfigStore.getDefaultMapConfig();
        if (mapConfig && DataUtil.asItem(mapConfig)) {
            FormActions.startEditFormItem(this.DATA.FORM_DEFAULTMAPCONFIGFORM, { mapConfigId: DataUtil.asItem(mapConfig).id });
        } else {
            FormActions.startEditFormItem(this.DATA.FORM_DEFAULTMAPCONFIGFORM, {});
        }
    }

    openDeleteDefaultMapConfigForm() {
        FormActions.startEditFormItem(this.DATA.FORM_RESETDEFAULTMAPCONFIGFORM, {});
    }

    onSubmitDefaultMapConfigForm(formData, validation, formId) {
        if (!(validation.mapConfigId)) {
            MapConfigActions.setDefaultMapConfig({
                mapConfigId: formData.mapConfigId,
                groupId: AppContext.getScopeGroupId()
            }, formId, true);

            MapConfigActions.itemDefaultGrouped('GroupDefaultMapConfig_' + AppContext.getScopeGroupId(), { groupId: AppContext.getScopeGroupId() });
        }
    }

    onSubmitDefaultMapDeleteConfirmForm(formData, validation, formId) {
        MapConfigActions.resetDefaultMapConfig({
            groupId: AppContext.getScopeGroupId()
        }, formId, true);
    }

    onSelectMapConfig(mapConfig) {
        let copyConf = JSON.parse(JSON.stringify(mapConfig));

        FormActions.startEditFormItem(this.DATA.FORM_MAPCONFIGEDITFORM, copyConf);
    }

    onDeleteMapConfig(mapConfig) {
        MapConfigActions.deleteMapConfig(mapConfig);
    }

    onSubmitMapConfig(mapConfig, validation, formId) {
        if (!(validation.title || validation.description || validation.latitude || validation.longitude || validation.zoom)) {

            if (mapConfig.id) {
                MapConfigActions.updateMapConfig(mapConfig, formId, true);
            } else {
                MapConfigActions.addMapConfig(mapConfig, formId, true);
            }
        }
    }

    handleSubmitCopyModal(formData) {
        const mapConfigCopy = JSON.parse(JSON.stringify(formData.mapConfig));

        const deleteIDs = (data) => {
            data.forEach((item) => {
                if (item.type === 'LayerSet') {
                    delete item.id;
                    return deleteIDs(item.children);
                }
            });
        };

        delete mapConfigCopy.uuid;
        delete mapConfigCopy.id;
        deleteIDs(mapConfigCopy.children);

        this.onSelectMapConfig(mapConfigCopy);

        this.setState({
            showCopyModal: false
        });
    }

    handleCancelCopyModal() {
        this.setState({
            showCopyModal: false
        });
    }

    openCopyModal() {
        this.setState({
            showCopyModal: true
        });
    }

    render() {
        const { groupMapConfigs, mapConfigs, logicalLayers, showCopyModal } = this.state;

        return (
            <div className="padding-box">

                <MapConfigChooser
                    mapConfigs={groupMapConfigs}
                    onSelect={this.onSelectMapConfig.bind(this)}
                    onDelete={this.onDeleteMapConfig.bind(this)}
                />


                <ButtonToolbar>
                    <Button title=" Neue Karte erstellen" variant="primary" onClick={this.onNewMapConfig.bind(this)}>
                        Erstellen
                    </Button>

                    <Button title="Bestehende Karte kopieren"
                            variant="primary"
                            onClick={this.openCopyModal.bind(this)}>
                        Kopieren
                    </Button>

                    <Button title="Standard-Konfiguration für die Karte setzen" variant="primary"
                            onClick={this.openDefaultMapConfigForm.bind(this)}>
                        Standard einstellen
                    </Button>

                    <Button title="Standard-Konfiguration für die Karte zurücksetzen" variant="primary"
                            onClick={this.openDeleteDefaultMapConfigForm.bind(this)}>
                        Standard zurücksetzen
                    </Button>

                    <CustomModal
                        show={showCopyModal}
                        onHide={this.handleCancelCopyModal.bind(this)}>

                        <CustomModalBody>
                            <MapConfigCopyForm
                                formData={mapConfigs}
                                onSubmit={this.handleSubmitCopyModal.bind(this)}
                                onCancel={this.handleCancelCopyModal.bind(this)}
                            />
                        </CustomModalBody>

                    </CustomModal>
                </ButtonToolbar>

                <MapConfigEditFormHoc
                    formId={this.DATA.FORM_MAPCONFIGEDITFORM}
                    logicalLayers={logicalLayers}
                    onFormSubmit={this.onSubmitMapConfig.bind(this)}
                />

                <DefaultMapConfigEditFormHoc formId={this.DATA.FORM_DEFAULTMAPCONFIGFORM}
                                             mapConfigs={mapConfigs}
                                             onFormSubmit={this.onSubmitDefaultMapConfigForm.bind(this)}
                />

                <ConfirmFormContainer formId={this.DATA.FORM_RESETDEFAULTMAPCONFIGFORM}
                                      editRequired={false}
                                      onFormSubmit={this.onSubmitDefaultMapDeleteConfirmForm.bind(this)}
                                      Content="Wollen Sie die Standard Kartenkonfiguration wirklich zurücksetzen?"

                />
            </div>
        );
    }
}

export default ContextContainer.create(MapConfigWidget);



// WEBPACK FOOTER //
// ./js/widgets/MapConfigWidget.jsx